export default __webpack_public_path__ + "static/icon_slack_new-e0b8ae82448f2a8230cc2d9a39b544f9.svg";